import { render, staticRenderFns } from "./AddNewSubject.vue?vue&type=template&id=27488948&"
import script from "./AddNewSubject.vue?vue&type=script&lang=js&"
export * from "./AddNewSubject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports